
  <h2 mat-dialog-title>Detalles de la Meta</h2>
  
  <mat-dialog-content>
    <div class="container py-3">
      <!-- Información principal -->
      <div class="row mb-4">
        <div class="col-12">
          <mat-card>
            <mat-card-content>
              <div class="row">
                <div class="col-md-6">
                  <p><strong>Periodo:</strong> {{data.meta.periodo}}</p>
                  <p><strong>Vendedor:</strong> {{data.vendedorNombre}}</p>
                </div>
                <div class="col-md-6">
                  <p><strong>Valor Meta:</strong> {{data.meta.valor_meta | currency:'COP':'symbol-narrow':'1.0-0'}}</p>
                  <p><strong>Meta Recalculada:</strong> {{data.meta.meta_recalculada | currency:'COP':'symbol-narrow':'1.0-0'}}</p>
                  <p><strong>Días Ausentismos:</strong> {{data.meta.dias_ausentismos}}</p>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>

      <!-- Información de auditoría -->
      <div class="row">
        <div class="col-md-6">
          <mat-card>
            <mat-card-header>
              <mat-card-title class="fs-6">Información de Creación</mat-card-title>
            </mat-card-header>
            <mat-card-content class="pt-3">
              <p><strong>Usuario:</strong> {{data.meta.usuario_creacion}}</p>
              <p><strong>Fecha:</strong> {{data.meta.fecha_creacion | date:'dd/MM/yyyy'}}</p>
            </mat-card-content>
          </mat-card>
        </div>
        <div class="col-md-6" *ngIf="data.meta.usuario_modificacion">
          <mat-card>
            <mat-card-header>
              <mat-card-title class="fs-6">Última Modificación</mat-card-title>
            </mat-card-header>
            <mat-card-content class="pt-3">
              <p><strong>Usuario:</strong> {{data.meta.usuario_modificacion}}</p>
              <p><strong>Fecha:</strong> {{data.meta.fecha_modificacion | date:'dd/MM/yyyy'}}</p>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>
  </mat-dialog-content>
  
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cerrar</button>
  </mat-dialog-actions>

